import type {PayloadAction} from '@reduxjs/toolkit'
import {createSlice} from '@reduxjs/toolkit'

interface SelectedProgram {
  programId?: string
  programName?: string
  validationStatus?: string
  [key: string]: any // Allow other row data
}

interface EditStatusState {
  selectedProgram: SelectedProgram | null
}

const initialState: EditStatusState = {
  selectedProgram: null,
}

const editStatusSlice = createSlice({
  name: 'editStatus',
  initialState,
  reducers: {
    setSelectedProgram: (state, action: PayloadAction<SelectedProgram>) => {
      state.selectedProgram = action.payload
    },
    clearSelectedProgram: state => {
      state.selectedProgram = null
    },
  },
})

export const {setSelectedProgram, clearSelectedProgram} = editStatusSlice.actions
export default editStatusSlice.reducer
